export const MIN_ATTENDEE_COUNT = 2;

/**
 * Determines if a calendar event should be shown in meeting lists.
 * An event is shown if it has at least MIN_ATTENDEE_COUNT attendees,
 * OR if it has a video conferencing link (even with just 1 attendee).
 */
export const shouldShowMeeting = (
  attendeeCount: number | null | undefined,
  meetLink: string | null | undefined
): boolean => {
  const count = attendeeCount ?? 0;
  return count >= MIN_ATTENDEE_COUNT || (!!meetLink && meetLink.trim().length > 0);
};
